// extracted by mini-css-extract-plugin
export var btn = "Contact-module--btn--8cbcb";
export var core = "Contact-module--core--dd369";
export var whatsapp = "Contact-module--whatsapp--b0a53";